import React, { useState, useEffect, useRef } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import Drilldown from 'highcharts/modules/drilldown';
import redirectURL from "../redirectURL";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';



import { Modal } from 'react-bootstrap';
Drilldown(Highcharts);  // Enable drill-down functionality
const DEPSReportedDashboard = () => {
    var [overly, setoverly] = useState('show-n')
    var [loadshow, setloadshow] = useState('show-n');
    var [ftlDamage, setFtlDamage]= useState(0);
    var [ftlExcess, setFtlExcess]= useState(0);
    var [ftlShort, setFtlShort]= useState(0);
    var [ftlPilferage, setFtlPilferage]= useState(0);
    var [ptlDamage, setptlDamage]= useState(0);
    var [ptlExcess, setptlExcess]= useState(0);
    var [ptlShort, setptlShort]= useState(0);
    var [ptlPilferage, setptlPilferage]= useState(0);
    const [chartOptions, setChartOptions] = useState({});  // State to store chart options
    var [ ftlDamageData, setFtlDamageData] = useState([]);
    var [ ftlExcessData, setFtlExcessData] = useState([]);
    var [ ftlShortData, setFtlShortData] = useState([]);
    var [ ftlPilferageData, setFtlPilferageData] = useState([]);
    var [ ptlDamageData, setPtlDamageData] = useState([]);
    var [ ptlExcessData, setPtlExcessData] = useState([]);
    var [ ptlShortData, setPtlShortData] = useState([]);
    var [ ptlPilferageData, setPtlPilferageData] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false); 
    var [title, setTitle] = useState('FTL Damage Consignments');
    const [defaultColDef] = useState({
        sortable: true,
        filter: true,
        resizable: true
    });
    const gridApiRef = useRef(null);
    const gridColumnApiRef = useRef(null);
    const [rowData, setRowData] = useState();
    const statusBar = {
        statusPanels: [
            {
                statusPanel: "agTotalAndFilteredRowCountComponent",
                align: "left"
            },
            {
                statusPanel: "agTotalRowCountComponent",
                align: "center"
            },
            { statusPanel: "agFilteredRowCountComponent" },
            { statusPanel: "agSelectedRowCountComponent" },
            { statusPanel: "agAggregationComponent" }
        ]
    };
    const sideBar = {
        toolPanels: [
            {
                id: "columns",
                labelDefault: "Columns",
                labelKey: "columns",
                iconKey: "columns",
                toolPanel: "agColumnsToolPanel"
            },
            {
                id: "filters",
                labelDefault: "Filters",
                labelKey: "filters",
                iconKey: "filter",
                toolPanel: "agFiltersToolPanel"
            }
        ],
    };



    useEffect(() => {
        getData();
    }, [])

    useEffect(() => {
        // Update chart options when data changes
        setChartOptions({
            chart: {
                type: 'column',
                height: 250
            },
            title: {
                text: ''
            },
            xAxis: {
                type: 'category'
            },
            yAxis: {
                title: {
                    text: 'No. of DEPS Consignments (%)'
                },
               
            },
            plotOptions: {
                series: {
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: true,
                        format: '{point.y}%'
                    },
                    point: {
                        events: {
                            click: function() {
                                if (this.name === 'Damage' && this.series.name === 'FTL Consignments') {
                                    // Open modal to show damage records
                                    setTitle("FTL Damage Consignments")
                                    setRowData(ftlDamageData);
                                    setIsModalOpen(true);
                                }else if (this.name === 'Excess' && this.series.name === 'FTL Consignments') {
                                    // Open modal to show damage records
                                    setRowData(ftlExcessData);
                                    setTitle("FTL Excess Consignments")

                                    setIsModalOpen(true);
                                }else if (this.name === 'Pilferage' && this.series.name === 'FTL Consignments') {
                                    // Open modal to show damage records
                                    setRowData(ftlPilferageData);
                                    setTitle("FTL Pilferage Consignments")
                                    setIsModalOpen(true);
                                }else if (this.name === 'Shortage' && this.series.name === 'FTL Consignments') {
                                    // Open modal to show damage records
                                    setRowData(ftlShortData);
                                    setTitle("FTL Shortage Consignments")
                                    setIsModalOpen(true);
                                }else if (this.name === 'Damage' && this.series.name === 'PTL Consignments') {
                                    // Open modal to show damage records
                                    setRowData(ptlDamageData);
                                    setTitle("PTL Damage Consignments")
                                    setIsModalOpen(true);
                                }else if (this.name === 'Excess' && this.series.name === 'PTL Consignments') {
                                    // Open modal to show damage records
                                    setRowData(ptlExcessData);
                                    setTitle("PTL Excess Consignments")
                                    setIsModalOpen(true);
                                }else if (this.name === 'Pilferage' && this.series.name === 'PTL Consignments') {
                                    // Open modal to show damage records
                                    setRowData(ptlPilferageData);
                                    setTitle("PTL Pilferage Consignments")
                                    setIsModalOpen(true);
                                }else if (this.name === 'Shortage' && this.series.name === 'PTL Consignments') {
                                    // Open modal to show damage records
                                    setRowData(ptlShortData);
                                    setTitle("PTL Shortage Consignments")
                                    setIsModalOpen(true);
                                }
                            }
                            }
                        }
                    }
                },
            tooltip: {
                headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
                pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}%</b><br/>'
            },
            series: [
                {
                    name: "FTL Consignments",
                    colorByPoint: true,
                    data: [
                        {
                            name: "Damage",
                            y: ftlDamage,  // Number of damage consignments in FTL
                            // drilldown: "damageFTL"
                        },
                        {
                            name: "Excess",
                            y: ftlExcess,  // Number of excess consignments in FTL
                            // drilldown: "excessFTL"
                        },
                        {
                            name: "Pilferage",
                            y: ftlPilferage,  // Number of pilferage consignments in FTL
                            // drilldown: "pilferageFTL"
                        },
                        {
                            name: "Shortage",
                            y: ftlShort,  // Number of shortage consignments in FTL
                            // drilldown: "shortageFTL"
                        }
                    ]
                },
                {
                    name: "PTL Consignments",
                    colorByPoint: true,
                    data: [
                        {
                            name: "Damage",
                            y: ptlDamage,  // Number of damage consignments in PTL
                            // drilldown: "damagePTL"
                        },
                        {
                            name: "Excess",
                            y: ptlExcess,  // Number of excess consignments in PTL
                            // drilldown: "excessPTL"
                        },
                        {
                            name: "Pilferage",
                            y: ptlPilferage,  // Number of pilferage consignments in PTL
                            // drilldown: "pilferagePTL"
                        },
                        {
                            name: "Shortage",
                            y: ptlShort,  // Number of shortage consignments in PTL
                            // drilldown: "shortagePTL"
                        }
                    ]
                }
            ],
            drilldown: {
                series: [
                    {
                        id: 'damageFTL',
                        name: 'FTL Damage Details',
                        data: [
                            ['Trip 1', 1],
                            ['Trip 2', 2],
                            ['Trip 3', 1],
                            ['Trip 4', 1]
                        ]
                    },
                    {
                        id: 'excessFTL',
                        name: 'FTL Excess Details',
                        data: [
                            ['Trip 1', 1],
                            ['Trip 2', 1],
                            ['Trip 3', 1]
                        ]
                    },
                    {
                        id: 'pilferageFTL',
                        name: 'FTL Pilferage Details',
                        data: [
                            ['Trip 1', 1],
                            ['Trip 2', 1]
                        ]
                    },
                    {
                        id: 'shortageFTL',
                        name: 'FTL Shortage Details',
                        data: [
                            ['Trip 1', 1]
                        ]
                    },
                    // PTL drilldown data
                    {
                        id: 'damagePTL',
                        name: 'PTL Damage Details',
                        data: [
                            ['Trip 1', 1],
                            ['Trip 2', 2],
                            ['Trip 3', 1]
                        ]
                    },
                    {
                        id: 'excessPTL',
                        name: 'PTL Excess Details',
                        data: [
                            ['Trip 1', 1],
                            ['Trip 2', 1]
                        ]
                    },
                    {
                        id: 'pilferagePTL',
                        name: 'PTL Pilferage Details',
                        data: [
                            ['Trip 1', 1]
                        ]
                    },
                    {
                        id: 'shortagePTL',
                        name: 'PTL Shortage Details',
                        data: [
                            ['Trip 1', 1],
                            ['Trip 2', 1],
                            ['Trip 3', 1]
                        ]
                    }
                ]
            },
            exporting: {
                enabled: false // This disables the context menu (exporting options)
              }
        });
    }, [ftlDamage, ftlExcess, ftlShort, ftlPilferage, ptlDamage, ptlExcess, ptlShort, ptlPilferage]);

    const getData = () => {
        setloadshow('show-m')
        
        redirectURL.post('/consignments/getdepsreport').then((resp) => {
            try {
                var data = resp.data;

                setFtlDamageData(data.ftlDamageRecords)
                setFtlExcessData(data.ftlExcessRecords)
                setFtlShortData(data.ftlShortRecords)
                setFtlPilferageData(data.ftlPilferageRecords)

                setPtlDamageData(data.ptlDamageRecords)
                setPtlExcessData(data.ptlExcessRecords)
                setPtlShortData(data.ptlShortRecords)
                setPtlPilferageData(data.ptlPilferageRecords)


        
                var ftlDamageRecordsCount = data.ftlDamageRecords.length;
                var ftlExcessRecordsCount = data.ftlExcessRecords.length;
                var ftlShortRecordsCount = data.ftlShortRecords.length;
                var ftlPilferageRecordsCount = data.ftlPilferageRecords.length;

                var ptlDamageRecordsCount = data.ptlDamageRecords.length;
                var ptlExcessRecordsCount = data.ptlExcessRecords.length;
                var ptlShortRecordsCount = data.ptlShortRecords.length;
                var ptlPilferageRecordsCount = data.ptlPilferageRecords.length;

                

                // Now calculate the percentage
                var ftlDamageRecords = parseFloat(((ftlDamageRecordsCount / data.ftlDeliveredRecords) * 100).toFixed(2));
                var ftlExcessRecords = parseFloat(((ftlExcessRecordsCount / data.ftlDeliveredRecords) * 100).toFixed(2));
                var ftlShortRecords = parseFloat(((ftlShortRecordsCount / data.ftlDeliveredRecords) * 100).toFixed(2));
                var ftlPilferageRecords = parseFloat(((ftlPilferageRecordsCount / data.ftlDeliveredRecords) * 100).toFixed(2));

                var ptlDamageRecords = parseFloat(((ptlDamageRecordsCount / data.ptlDeliveredRecords) * 100).toFixed(2));
                var ptlExcessRecords = parseFloat(((ptlExcessRecordsCount / data.ptlDeliveredRecords) * 100).toFixed(2));
                var ptlShortRecords = parseFloat(((ptlShortRecordsCount / data.ptlDeliveredRecords) * 100).toFixed(2));
                var ptlPilferageRecords = parseFloat(((ptlPilferageRecordsCount / data.ptlDeliveredRecords) * 100).toFixed(2));

                // Set the data for each series
                setFtlDamage(ftlDamageRecords);
                setFtlExcess(ftlExcessRecords);
                setFtlShort(ftlShortRecords);
                setFtlPilferage(ftlPilferageRecords);
                setptlDamage(ptlDamageRecords);
                setptlExcess(ptlExcessRecords);
                setptlShort(ptlShortRecords);
                setptlPilferage(ptlPilferageRecords);
                

                // setFtlDamage(7);
                // setFtlExcess(2);
                // setFtlShort(5);
                // setFtlPilferage(1);
                // setptlDamage(0);
                // setptlExcess(4);
                // setptlShort(4);
                // setptlPilferage(1);
        
            } catch (e) {
                console.error('Error:', e);
            } finally {
                setTimeout(() => {
                    setloadshow('show-n');
                }, 3000);
            }
        }).catch(error => {
            console.error('Fetch error:', error);
            setTimeout(() => {
                setloadshow('show-n');
            }, 3000);
        });
    }

    const onClickHideAll = () => {
        setloadshow('show-n')
    }
    const onCloseModal = () => {
		setIsModalOpen(false);
	};
    const onGridReady = params => {
        // Assign the APIs to refs
        gridApiRef.current = params.api;
        gridColumnApiRef.current = params.columnApi;
        
        // Now you can use gridApiRef.current and gridColumnApiRef.current safely
    };
    const onGridState = () => {
        if (gridApiRef.current && gridColumnApiRef.current) {
          // Get Current Columns State and Store in a variable
          const colState = gridColumnApiRef.current.getColumnState();
    
          // Get Current RowGroup Columns State
          const rowGroupState = gridColumnApiRef.current.getRowGroupColumns();
    
          // Get Current Pivot Columns State (when Pivot Mode is enabled)
          const pivotColumns = gridColumnApiRef.current.getPivotColumns();
    
          // Get Current Filter State and store it in window.filterState
          const filterState = gridApiRef.current.getFilterModel();
          window.filterState = filterState;
    
          // Set Filter Model (if you want to re-apply the same filter state)
          gridApiRef.current.setFilterModel(window.filterState);
        }
      };
      var columnwithDefs = [
        {
            headerName: "Source",
            field: "consigner_state",
            width: 100,
            // filter: false,
            resizable: true,
            // cellClass : params =>{
            // 	if(params.data.stopages == 1) return 'red'
            // 		return 'green'
            // }
        },
        {
            headerName: "Destination",
            field: "consignee_state",
            width: 120,
            // filter: false,
            resizable: true,
           
            // cellClass : params =>{
            // 	if(params.data.stopages == 1) return 'red'
            // 		return 'green'
            // }
        },
        {
            headerName: "Courier Partner",
            field: "transporter_name",
            width: 150,
            // filter: false,
            resizable: true,
           
            // cellClass : params =>{
            // 	if(params.data.stopages == 1) return 'red'
            // 		return 'green'
            // }
        },
       

    ]

    return (
        <>
            <div className='card-header2'>
                <div className='d-flex justify-content-between'>
                    <h1 className='heading3 mt-20p ml-5p' style={{ width: "240px" }}>DEPS Reported %</h1>
                </div>
                <HighchartsReact highcharts={Highcharts} options={chartOptions} />
            </div>
            <Modal
				show={isModalOpen}
				onHide={onCloseModal}
				dialogClassName="my-modal"
				centered
				>
				<Modal.Header>
					<Modal.Title style={{fontSize:"15px"}}>{title}</Modal.Title>
					<div className="close-btn-container">
					<button
						type="button"
						className="btn btn-sm btn-icon btn-outline-primary close-button"
						data-bs-dismiss="modal"
						aria-label="Close"
						onClick={onCloseModal}
					>
						<i className="fa fa-times"></i>
					</button>
					</div>
				</Modal.Header>
				<Modal.Body className="view-task">
					<div
					className="row modelGrid"
					style={{ padding: "5px 0px", width: "100%", overflow: "hidden", zIndex: "9999" }}
					>
					<div className={"col-sm-12 col-lg-12 col-md-12"} style={{ padding: "0px 20px 0px 20px", background: "#fff" }}>
						<div
						id="myGrid"
						style={{ height: "580px", width: "100%", marginTop: "10px" }}
						className="ag-theme-balham"
						>
						<AgGridReact
							columnDefs={columnwithDefs}
							defaultColDef={defaultColDef}
							rowData={rowData}
							enableCharts={true}
							enableRangeSelection={true}
							// autoGroupColumnDef={autoGroupColumnDef}
							onGridReady={onGridReady}
							onGridState={onGridState}
							statusBar={statusBar}
							sideBar= {sideBar}
							paginationPageSize={50}
							pagination={true}
							// frameworkComponents={customLoadingCellRenderer: CustomLoadingCellRenderer}
							// detailCellRendererParams={this.state.detailCellRendererParams}
							stopEditingWhenGridLosesFocus={true}
							floatingFilter={false}
							enableCellChangeFlash={true}
							suppressCellFlash={true}
							// rowClassRules={this.state.rowClassRules}
							// gridOptions={{
							// context: { componentParent: this }
							// }}
							masterDetail={true}
							// overlayNoRowsTemplate={this.state.overlayNoRowsTemplate}
						/>
						</div>
					</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					{/* <button type="button" className="btn btn-secondary" onClick={onCloseModal}>
					Close
					</button> */}
				</Modal.Footer>
				</Modal>

            <div className={"dataLoadpage1 " + (loadshow)}></div>
            <div className={"dataLoadpageimg " + (loadshow)}>
                <div className="loader-box"><div className="loader"></div></div>
            </div>
            <div className={"overlay-part " + (overly)} onClick={onClickHideAll}></div>
        </>
    )
}

export default DEPSReportedDashboard;
